const ADMIN_ROLE = 'admin'
const STORE_ROLE = 'store'

const userRoles = {
  ADMIN_ROLE,
  STORE_ROLE
}

module.exports = userRoles
